import React, { memo } from "react";
import { FormikProvider, Form, FieldArray } from "formik";
import { Icon } from "@iconify/react";
import { TextField, Box, Chip, Grid, Switch } from "@mui/material";
import MotionWrapper from "../../MotionWrapper";

const ViewOptionsGrid = memo(({ formik }) => {
  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <FieldArray name="options">
          {({ push, remove }) => (
            <Box sx={{ overflowY: "auto", maxHeight: "80vh", p: 2 }}>
              <Grid container spacing={2}>
                {formik.values.options.map((option, optionIndex) => (
                  <Grid item xs={12} sm={6} md={4} key={optionIndex}>
                    <MotionWrapper directions="right" delay={0.1}>
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          p: 2,
                          backgroundColor: "grey.200",
                          borderRadius: 3,
                        }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Chip
                            label={`Option ${optionIndex + 1}`}
                            sx={{ fontWeight: "bolder" }}
                            icon={
                              <Icon icon="line-md:list-3-twotone" width="20" />
                            }
                            variant="contained"
                            color="primary"
                            size="small"
                          />
                        </Box>

                        <TextField
                          label="No Of Sessions"
                          name={`options.${optionIndex}.NoOfSessions`}
                          value={option.NoOfSessions}
                          margin="normal"
                          fullWidth
                          disabled
                          type="number"
                        />
                        <TextField
                          label="Amount"
                          name={`options.${optionIndex}.amount`}
                          value={option.amount}
                          fullWidth
                          disabled
                          type="number"
                          margin="normal"
                        />

                        <TextField
                          label="Amount Aed"
                          name={`options.${optionIndex}.amountAed`}
                          value={option.amountAed}
                          fullWidth
                          disabled
                          type="number"
                          margin="normal"
                        />

                        {/* Inner Options Array */}
                        <FieldArray name={`options.${optionIndex}.options`}>
                          {({ push: pushInner, remove: removeInner }) => (
                            <Box sx={{ mt: 2 }}>
                              {option.options.map((opt, optIndex) => (
                                <MotionWrapper
                                  key={optIndex}
                                  directions="top"
                                  delay={0.1}
                                >
                                  <Box
                                    sx={{
                                      pl: 2,
                                      pt: 1,
                                      border: "1px dashed #aaa",
                                      p: 2,
                                      backgroundColor: "white",
                                      borderRadius: 3,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        pb: 2,
                                      }}
                                    >
                                      <Chip
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        sx={{ fontWeight: "bolder" }}
                                        icon={
                                          <Icon
                                            icon="line-md:list-3-twotone"
                                            width="24"
                                          />
                                        }
                                        label={`Term Option ${optIndex + 1}`}
                                      />
                                    </Box>

                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        pb: 2,
                                      }}
                                    >
                                      <Chip
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        sx={{ fontWeight: "bolder" }}
                                        icon={
                                          <Icon
                                            icon="formkit:rupee"
                                            width="20"
                                          />
                                        }
                                        label={`Discounted INR Amount: ${
                                          option.amount -
                                          (option.amount * opt.discount) / 100
                                        }`}
                                      />

                                      <Chip
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        sx={{ fontWeight: "bolder", mt: 2 }}
                                        icon={
                                          <Icon
                                            icon="formkit:rupee"
                                            width="20"
                                          />
                                        }
                                        label={`Discounted AED Amount: ${
                                          option.amountAed -
                                          (option.amountAed * opt.discount) /
                                            100
                                        }`}
                                      />
                                    </Box>

                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Switch
                                        disabled
                                        checked={opt.active}
                                        name={`options.${optionIndex}.options.${optIndex}.active`}
                                        inputProps={{
                                          "aria-label": "controlled",
                                        }}
                                      />
                                    </Box>

                                    <TextField
                                      label="Discount"
                                      name={`options.${optionIndex}.options.${optIndex}.discount`}
                                      value={opt.discount}
                                      disabled
                                      fullWidth
                                      margin="normal"
                                      type="number"
                                    />

                                    {/* Items Array inside Inner Options */}
                                    <FieldArray
                                      name={`options.${optionIndex}.options.${optIndex}.terms`}
                                    >
                                      {({
                                        push: pushItem,
                                        remove: removeItem,
                                      }) => (
                                        <Box>
                                          {opt.terms.map((term, termIndex) => (
                                            <MotionWrapper
                                              key={termIndex}
                                              directions="top"
                                              delay={0.1}
                                            >
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                  mb: 1,
                                                }}
                                              >
                                                <TextField
                                                  label={`INR Term ${
                                                    termIndex + 1
                                                  }`}
                                                  name={`options.${optionIndex}.options.${optIndex}.terms.${termIndex}.InrTerm`}
                                                  type="number"
                                                  disabled
                                                  margin="normal"
                                                  value={term.InrTerm || ""}
                                                  fullWidth
                                                />

                                                <TextField
                                                  label={`AED Term ${
                                                    termIndex + 1
                                                  }`}
                                                  name={`options.${optionIndex}.options.${optIndex}.terms.${termIndex}.AedTerm`}
                                                  type="number"
                                                  disabled
                                                  margin="normal"
                                                  value={term.AedTerm || ""}
                                                  fullWidth
                                                />
                                              </Box>
                                            </MotionWrapper>
                                          ))}
                                        </Box>
                                      )}
                                    </FieldArray>
                                  </Box>
                                </MotionWrapper>
                              ))}
                            </Box>
                          )}
                        </FieldArray>
                      </Box>
                    </MotionWrapper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
        </FieldArray>
      </Form>
    </FormikProvider>
  );
});

export default ViewOptionsGrid;
